import {useEffect} from "react";
import {useLocation} from "react-router-dom";

const DotDesktop = ({adSlot}) => {
    const location = useLocation()

    useEffect(() => {
            try {
                var domain = 'xdloadout.pro';
                var slot = `w2g-slot${adSlot}`;
                if (window.self !== window.parent) {
                    var d = window.top.document, w = window.parent;
                    var parent = this.frameElement;
                    parent.style.display = "none";
                } else {
                    var d = document, w = window, parent = null;
                    if (typeof d.currentScript !== 'undefined') {
                        parent = d.currentScript;
                        if (parent == null) {
                            parent = document.getElementById(slot + '-cnt');
                        }
                    } else {
                        parent = d.body.lastElementChild;
                    }
                }
                d.addEventListener('wtgLoaded', function (e) {
                    if (typeof w.w2g.single === 'function') {
                        w.w2g.single(domain, slot, parent);
                    }
                }, false);
                if (w.w2gLoaded === undefined) {
                    w.w2gLoaded = 0;
                }
                if (w.w2gLoaded < 1 && w.w2g === undefined) {
                    var element = d.createElement('script'), head = d.head || d.getElementsByTagName('head')[0];
                    element.type = 'text/javascript';
                    element.async = true;
                    element.src = 'https://lib.wtg-ads.com/lib.single.wtg.min.js';
                    head.appendChild(element);
                    w.w2gLoaded++;
                }
                if (w.w2g !== undefined && typeof w.w2g.single === 'function') {
                    w.w2g.single(domain, slot, parent);
                }
            } catch (e) {
                console.log(e)
            }
        }, [location, adSlot])

    return <div id={`w2g-slot${adSlot}-cnt`}></div>

}

export default DotDesktop

